import './ScreenshotContainer.css';

import { useState } from 'react';

export default function ScreenshotContainer() {
    const [activePhoto, setActivePhoto] = useState(null);

    function enlargeScreenshot(index) {
        setActivePhoto(index);
    }

    const photoUris = [
        '/screenshots/Screenshot1.png',
        '/screenshots/Screenshot5.png',
        '/screenshots/Screenshot6.png',
        '/screenshots/Screenshot8.png',
        '/screenshots/Screenshot9.png',
        '/screenshots/Screenshot10.png',
        '/screenshots/Screenshot11.png',
        '/screenshots/Screenshot12.png',
        '/screenshots/Screenshot13.png',
        '/screenshots/Screenshot14.png',
        '/screenshots/Screenshot15.png',
        '/screenshots/Screenshot16.png',
        '/screenshots/Screenshot17.png'
    ]

    return (
        <section className="screenshot-container">
            <ul>
                {photoUris.map((p, i) => 
                    <li key={i}>
                        <figure>
                            <img 
                            key={i} 
                            src={p} 
                            alt="screenshot" 
                            onClick={() => enlargeScreenshot(i)}
                            className={activePhoto === i ? 'active' : ''} />
                        </figure>
                    </li>
                )}
            </ul>
        </section>
    )
}